import { number } from "maz-ui";
import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);
dayjs.locale('id')

export function numberFormatter(value: any) {
  return number(value, "id-ID");
};

export const day = (value?: any) => dayjs(value);

export function dateFormatter(value: any = dayjs()) {
  return dayjs(value).format("MMM, DD YYYY");
};

export function timeFormatter(value: any = dayjs()) {
  return dayjs(value).format("HH:mm");
};

export function dateTimeFormatter(value: any = dayjs()) {
  return dayjs(value).format("MMM, DD YYYY HH:mm");
};

export function formatDuration(minutes: number): string {
  const dur = dayjs.duration(minutes, 'minutes');
  const hours = dur.hours();
  const mins = dur.minutes();

  const parts = [];
  if (hours > 0) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  if (mins > 0) parts.push(`${mins} minute${mins > 1 ? 's' : ''}`);

  return parts.join(' ');
}
